import { UserRole } from '../../components/common/header/photo/head-bar/newsComponent/utils/userRoleHelper';
import Api from '../../shared/Api';
import { INewsItem } from './NewsItem';

type BrokerChainDto = {
    id: number;
    name: string;
};

export interface RecipientPayload {
    role: UserRole;
    brokerChainId: number | null;
}

export interface NewsItemPayload {
    id: number;
    title: string;
    content: string;
    recipients: RecipientPayload[];
    startDate: string | null;
    visibleDate: string | null;
    endDate: string | null;
    visible: boolean;
    status?: number;
}

export interface NewsFeedItem {
    id: number;
    title: string;
    content: string;
    date: string;
    isRead: boolean;
}

const backgroundRequest = { redirectOnAccessErrors: false };

export class NewsApi {
    static async getNewsFeed(): Promise<NewsFeedItem[]> {
        const newsItems = await new Api(backgroundRequest).get('/views/news/feed');
        return Array.isArray(newsItems) ? newsItems : [];
    }

    static async markNewsAsRead(newsItemIds: number[]): Promise<void> {
        await new Api(backgroundRequest).post('/views/news/feed/read', { newsItemIds });
    }

    static async createNewsItem(data: NewsItemPayload): Promise<void> {
        await new Api().post('/views/news', data);
    }

    static async getNewsItems(): Promise<INewsItem[]> {
        const newsItems = await new Api().get('/views/news');
        return Array.isArray(newsItems) ? newsItems : [];
    }

    static async updateNewsItem(data: NewsItemPayload): Promise<void> {
        await new Api().put(`/views/news/${data.id}`, data);
    }

    static async toggleNewsVisibility(data: NewsItemPayload, visible: boolean): Promise<void> {
        await this.updateNewsItem({ ...data, visible });
    }

    static async getBrokerChains(): Promise<BrokerChainDto[]> {
        const brokerChains = await new Api().get('/views/news/brokerchains');

        if (!Array.isArray(brokerChains)) {
            return [];
        }

        return brokerChains
            .map((brokerChain) => ({
                id: Number(brokerChain.id),
                name: String(brokerChain.name).trim()
            }))
            .filter((brokerChain) => brokerChain.id > 0 && brokerChain.name)
            .sort((a, b) => a.name.localeCompare(b.name));
    }
}
